namespace PaperTrail.NewsletterControl {
    export interface NewsletterStoryRow {
        NewsletterStoryId?: number;
        NewsletterId?: number;
        StoryId?: number;
        StoryBlocks?: StoryTextBlockRow[];
        StoryHighlights?: StoryHighlightRow[];
        StoryImages?: StoryImageRow[];
        StoryAds?: StoryAdvertisementRow[];
        StoryNews?: StoryNewsRow[];
        NewsletterNewsletterName?: string;
        NewsletterCreatedBy?: number;
        NewsletterDateCreated?: string;
        NewsletterDateModified?: string;
        NewsletterModifiedBy?: number;
        NewsletterPages?: number;
        NewsletterStyleSheetId?: number;
        StoryUserId?: number;
        UserDisplayName?: string;
        StoryNewsletterId?: number;
        StoryDateSubmitted?: string;
        StoryDateModified?: string;
        StoryDatePublished?: string;
        StoryTitle?: string;
        StorySubtitle?: string;
        StoryPage?: number;
        StoryPosition?: number;
        StoryCharacters?: number;
        StoryDoPageBreak?: boolean;
        StoryRows?: number;
        StoryColumns?: number;
        StoryIsPlaced?: boolean;
        StoryStyleSheetId?: number;
        StoryRank?: number;
        StoryPageTemplateId?: number;
        StoryPageTemplateSectionId?: number;
    }

    export namespace NewsletterStoryRow {
        export const idProperty = 'NewsletterStoryId';
        export const localTextPrefix = 'NewsletterControl.NewsletterStory';
        export const lookupKey = 'NewsletterControl.NewsletterStory';

        export function getLookup(): Q.Lookup<NewsletterStoryRow> {
            return Q.getLookup<NewsletterStoryRow>('NewsletterControl.NewsletterStory');
        }
        export const deletePermission = 'Newsletter:Contributor';
        export const insertPermission = 'Newsletter:Contributor';
        export const readPermission = 'Newsletter:Contributor';
        export const updatePermission = 'Newsletter:Contributor';

        export declare const enum Fields {
            NewsletterStoryId = "NewsletterStoryId",
            NewsletterId = "NewsletterId",
            StoryId = "StoryId",
            StoryBlocks = "StoryBlocks",
            StoryHighlights = "StoryHighlights",
            StoryImages = "StoryImages",
            StoryAds = "StoryAds",
            StoryNews = "StoryNews",
            NewsletterNewsletterName = "NewsletterNewsletterName",
            NewsletterCreatedBy = "NewsletterCreatedBy",
            NewsletterDateCreated = "NewsletterDateCreated",
            NewsletterDateModified = "NewsletterDateModified",
            NewsletterModifiedBy = "NewsletterModifiedBy",
            NewsletterPages = "NewsletterPages",
            NewsletterStyleSheetId = "NewsletterStyleSheetId",
            StoryUserId = "StoryUserId",
            UserDisplayName = "UserDisplayName",
            StoryNewsletterId = "StoryNewsletterId",
            StoryDateSubmitted = "StoryDateSubmitted",
            StoryDateModified = "StoryDateModified",
            StoryDatePublished = "StoryDatePublished",
            StoryTitle = "StoryTitle",
            StorySubtitle = "StorySubtitle",
            StoryPage = "StoryPage",
            StoryPosition = "StoryPosition",
            StoryCharacters = "StoryCharacters",
            StoryDoPageBreak = "StoryDoPageBreak",
            StoryRows = "StoryRows",
            StoryColumns = "StoryColumns",
            StoryIsPlaced = "StoryIsPlaced",
            StoryStyleSheetId = "StoryStyleSheetId",
            StoryRank = "StoryRank",
            StoryPageTemplateId = "StoryPageTemplateId",
            StoryPageTemplateSectionId = "StoryPageTemplateSectionId"
        }
    }
}
